import { createSelector } from '@ngrx/store';
import { selectUser } from '../../users/selectors/user.selectors';
import { routingStatusTopicName } from '../helpers/routing-status-topic.helper';

export const selectRoutingStatusNotificationTopicName = createSelector(selectUser, user => routingStatusTopicName(user?.id));

